import { QueryKeys, useCustomQuery } from './index';
import Config from '../../config';
import { YesNoFlag } from '../types';
import { toastr } from 'react-redux-toastr';

type Flag = {
  activeFlag: YesNoFlag,
};

type UserBase = {
  email: string,
  firstName: string,
  lastName: string,
  sso: string,
};

type UserClient = {
  expirationDate: string,
  expirationSso: string,
  expirationSsoName: string,
}

export type UserWithActiveFlag = UserBase & Flag;

export type ExcelUser = UserWithActiveFlag & {
  clientName: string,
  roleName: string,
  privileges: string,
  assignmentType: string,
  assignments: string,
  expirationDate: string,
}

export type UserExpiration = UserWithActiveFlag & UserClient;
export type UserExpirationWithId = UserExpiration & { id: number };

export const useUsersExcelData = (callback: (data: ExcelUser[]) => void = () => null) =>
  useCustomQuery<ExcelUser[]>(
    [QueryKeys.users.ExcelData],
    {
      url: Config.endpoints.FETCH_USERS_EXCEL_DATA,
      errorMessage: 'Fetching user excel data failed',
      defaultData: [],
      enabled: false,
      onSuccess: callback,
      onError: error => {
        toastr.error('', error.message, Config.defaultToastrSettings);
      },
    }
  );

export const useUserExpiration = (cliendId: number) => useCustomQuery<UserExpiration[]>(
  [QueryKeys.users.ExpirationList],
  {
    url: Config.endpoints.FETCH_USERS_EXPIRATION.replace(':clientId', cliendId.toString()),
    errorMessage: 'Fetching users expiration by client failed',
    defaultData: [],
  }
);
